
import { Component, Prop, Vue } from 'bits/vue'
import { WallAccessRight } from 'enums'
import type { UserWallCollaborator } from 'types'
import AvatarImage from 'vuecomponents/avatar_image.vue'
import BaseIcon from 'vuecomponents/base_icon.vue'
import SurfacePanelSharePermissionsSelector from 'vuecomponents/surface_panel_share_permissions_selector.vue'

@Component({ components: { AvatarImage, BaseIcon, SurfacePanelSharePermissionsSelector } })
export default class SurfacePanelShareSubpanelMember extends Vue {
  @Prop({ required: true }) collaborator!: UserWallCollaborator
  @Prop({ required: true }) xResendInvitationButton!: boolean

  xMenu = false
  rightsList: WallAccessRight[] = [
    WallAccessRight.Read,
    WallAccessRight.Write,
    WallAccessRight.Edit,
    WallAccessRight.Administer,
  ]

  get collaboratorDisplayName(): string {
    return this.collaborator.name || this.collaborator.username
  }

  get emailDomainPart(): string {
    const emailSplit = (this.collaborator.email || '').split('@', 2)
    return emailSplit.length > 1 ? emailSplit[1] : ''
  }

  get emailUsernamePart(): string {
    const emailSplit = (this.collaborator.email || '').split('@', 2)
    return emailSplit.length > 1 ? emailSplit[0] : ''
  }

  setRight(right: WallAccessRight): void {
    this.$emit('set-right', { right })
  }
}
